import { Button, Icon } from '@aidkitorg/component-library'
import { useLocalizedStrings } from '../../../Localization';

export const SYNTHETIC_UID_COLUMN_NAME = "__synthetic_uid__";
export const SYNTHETIC_VIEW_APPLICANTS_COLUMN_NAME = "__synthetic_view_applicants__";

/**
 * Renders the View Applicants cell with a link to the applicant page
 * @param uid - The applicant UID value from getValue()
 * @returns React element or '--' if no UID
 */
export const renderViewApplicantsCell = (uid: any) => {
  const L = useLocalizedStrings()

  if (!uid) {
    return '--';
  }

  return (
    <Button href={`/a/${uid}`} variant="link" openInNewWindow>
      <div className="flex gap-2 items-center">
        {L.admin_panel.reports.view}
        <Icon size="sm" role="decorative" name="ArrowTopRightOnSquareIcon" />
      </div>
    </Button>
  );
};
